"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Tag = require("../../components/Tag/Tag.styles");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Tag = {
  defaultProps: {
    size: "small"
  },
  styles: function styles(theme) {
    return {
      root: {
        fontWeight: 600,
        padding: [theme.spacing.base / 4, theme.spacing.base / 4],
        borderRadius: 4
      },
      icon: {
        paddingInlineEnd: 0
      },
      translucent: {
        fontWeight: 600,
        color: theme.colors.baseContrast100,
        backgroundColor: _Tag.tagVars.get("mainColor30"),
        "& svg": {
          fill: theme.colors.baseContrast100
        }
      },
      translucentChildren: {
        "& > *": {
          color: theme.colors.baseContrast100
        }
      },
      translucentCount: {
        color: theme.colors.baseContrast070
      }
    };
  }
};
var _default = exports.default = Tag;